import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import {
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { customGlobalFilter } from "utils/common-helpers"
import { inactiveStaffColumns } from "utils/columns/Human Resource/humanResource"
import axios from "axios"
import configure from "configure"
import moment from "moment"

function TableContainer({ columns, data, onAddLogs }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  // useEffect(() => {
  //   setPageSize(10)
  // }, [setPageSize])
  // Render the UI for your table

  const [fixedHeading, setFixedHeading] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setFixedHeading(true)
      } else {
        setFixedHeading(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div className="mb-3 text-purple fs-5  fw-bold">
                Temporary Inactive Staff
              </div>
              <div className="col-10 d-flex justify-content-end align-items-center">
                <div className="col-8">
                  <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                    <div className="d-flex justify-content-end">
                      <div className="position-relative">
                        <label
                          htmlFor="search-bar-0"
                          className="search-label w-100 mb-0"
                        >
                          <span id="search-bar-0-label" className="sr-only">
                            Search this table
                          </span>
                          <input
                            onChange={e => setGlobalFilter(e.target.value)}
                            id="search-bar-0"
                            type="text"
                            className="border-radius form-control rounded h-100 w-100"
                            placeholder={`Search...`}
                            value={globalFilter || ""}
                          />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1 text-centers header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    const bgColor =
                      row?.original?.status == 1
                        ? "bg-green"
                        : row?.original?.status == 2
                        ? "bg-light-red"
                        : ""
                    return (
                      <tr
                        className={`row-hover ${bgColor}`}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`${cell.column.className}`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const InactiveStaff = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [addReasons, setAddReasons] = useState(false)
  const [type, setType] = useState(false)
  const token = secureLocalStorage.getItem("auth_token")
  const [punchId, setPunchId] = useState("")
  const [reason, setReason] = useState("")
  const [description, setDescription] = useState("")
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [date, setDate] = useState("")
  const [showReasons, setShowReasons] = useState(false)
  const [rejDescription, setRejDescription] = useState("")

  const toggleLoading = loading => {
    setLoading(loading)
  }

  // const getData = async () => {
  //   const response = await fetchNodeData(
  //     toggleLoading,
  //     `PendingPunchList/${localStorage.getItem("auth_id")}`,
  //     token
  //   )
  //   if (response?.status) {
  //     setData(response.data)
  //   }
  // }
  // useEffect(() => {
  //   if (data?.length == 0) {
  //     getData()
  //   }
  // }, [])

  const ondelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Logs?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#762C99",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          setLoading(true)
          const res = await axios.delete(
            `${configure.nodeApi}/wfhpunch/delete/${id}`
          )
          setLoading(false)
          if (res?.data?.status) {
            Swal.fire("Deleted!", "The Logs has been deleted.", "success")
            getData()
          }
        } catch (e) {
          console.log(e)
          Swal.fire("Error", "Something Went Wrong", "error")
        }
      }
    })
  }

  const onAction = (status, obj) => {
    if (status == 0) {
      setPunchId(obj?.id)
      setStartTime(obj?.startTime)
      setEndTime(obj?.endTime)
      setReason(obj?.reason)
      setDescription(obj?.description)
      setDate(moment(obj?.punch_date).format("YYYY-MM-DD"))
      setAddReasons(true)
    } else {
      ondelete(obj?.id)
    }
  }
  const onView = reason => {
    setShowReasons(true)
    setRejDescription(reason)
  }

  const statusChange = async (id, value) => {
    try {
      setLoading(true)

      const res = await axios.get(`${configure.nodeApi}/inactiveStaff/${id}`)

      setLoading(false)

      if (res?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: `Login access has been ${value ? "enabled" : "disabled"}.`,
          timer: 1200,
          showConfirmButton: false,
        })

        // refresh table data
        fetchData()
      } else {
        Swal.fire("Error", "Unable to update access", "error")
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire("Error", "Server Error", "error")
    }
  }

  const onStatusToggle = (user, checked) => {
  Swal.fire({
    title: "Are you sure?",
    text: `Do you want to ${checked ? "enable" : "disable"} login access?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#762C99",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, continue",
  }).then(result => {
    if (result.isConfirmed) {

      // CALL API
      statusChange(user.id, checked ? 1 : 0)

    } else {
      // ❌ REVERT switch state if cancelled
      user.login_access = checked ? 0 : 1
      setData(prev =>
        [...prev]
      )
    }
  })
}


  const column1 = useMemo(() => inactiveStaffColumns(onStatusToggle), [])

  const onAddTime = async e => {
    e.preventDefault()
    const formEntries = {
      startTime: startTime,
      endTime: endTime,
      reason: reason,
      description: description,
      date: date,
      userId: localStorage.getItem("auth_id"),
    }
    const res = type
      ? await FetchNodePostData(
          setLoading,
          `wfhpunch/addWfhPunch`,
          token,
          formEntries
        )
      : await FetchNodePutData(
          setLoading,
          `wfhpunch/edit`,
          punchId,
          formEntries
        )
    if (res?.data?.status) {
      getData()
      setAddReasons(false)
      setReason("")
      setDescription("")
      setStartTime("")
      setEndTime("")
      setDate("")
      setType(false)
      Swal.fire({
        icon: "success",
        text: `Your punch log has been ${
          type ? "Added" : "Edited"
        } successfully.`,
      })
    }
  }

  const onAddLogs = () => {
    setAddReasons(true)
    setType(true)
  }

  const fetchData = async () => {
    try {
      setLoading(true)

      const res = await axios.get(`${configure.nodeApi}/inactiveStaff`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      setLoading(false)

      if (res?.data?.success) {
        setData(res.data.data) // FULL user data + last_punch_date
      } else {
        Swal.fire("Error", "Unable to fetch inactive staff", "error")
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire("Error", "Server Error", "error")
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  <TableContainer
                    columns={column1}
                    data={data}
                    toggleLoading={toggleLoading}
                    onAddLogs={onAddLogs}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal isOpen={addReasons} size="md" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Edit Punch Log</h5>
          <button
            type="button"
            onClick={() => {
              setReason("")
              setDescription("")
              setStartTime("")
              setEndTime("")
              setDate("")
              setType(false)
              setAddReasons(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body pe-4 ">
          <form className="row" onSubmit={onAddTime}>
            <div className="col-md-12 mt-2">
              <label>
                Punch Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                placeholder="Enter Time"
                required
                value={date}
                onChange={e => setDate(e.target.value)}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label>
                Start Time <span className="text-danger">*</span>
              </label>
              <input
                type="time"
                step="1"
                className="form-control"
                placeholder="Enter Time"
                required
                value={startTime}
                onChange={e => setStartTime(e.target.value)}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label>
                End Time <span className="text-danger">*</span>
              </label>
              <input
                type="time"
                step="1"
                className="form-control"
                placeholder="Enter Time"
                required
                value={endTime}
                onChange={e => setEndTime(e.target.value)}
              />
            </div>
            <div className="col-md-12 mt-3">
              <label>
                Reason <span className="text-danger">*</span>
              </label>
              <select
                className="border-radius form-select"
                required
                value={reason}
                onChange={e => setReason(e.target.value)}
              >
                <option value="">Select Reason</option>
                <option value="on-call">On Call</option>
                <option value="other">Other</option>
              </select>
            </div>
            {reason != "" ? (
              <div className="col-md-12 mt-3">
                <label>
                  Actual Reason <span className="text-danger">*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter Actual Reason"
                  required
                  rows={5}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </div>
            ) : null}
            <div className="mt-4">
              <button type="submit" className="border-radius btn btn-purple">
                Submit
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <Modal isOpen={showReasons} size="md" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Reason For Disapprove</h5>
          <button
            type="button"
            onClick={() => {
              setShowReasons(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body pe-4 ">
          <form
            className=""
            onSubmit={e => {
              e.preventDefault()
            }}
          >
            <div className="col-md-12 ">
              <label>Reason</label>
              <textarea
                className="form-control"
                placeholder="Reason for Disapproval"
                value={rejDescription}
                onChange={e => setRejDescription(e.target.value)}
                disabled
              />
            </div>
          </form>
        </div>
      </Modal>
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default InactiveStaff
